export default {"src":"/_next/static/media/postgresql.1b536c2f.svg","height":264,"width":256,"blurWidth":0,"blurHeight":0};